module.exports = ":host {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.scss
// module id = ./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.scss
// module chunks = 0